import Vue from "vue";
import Router from "vue-router";
//---------------------------------------
Vue.use(Router);

export const constantRoutes = [
  {
    path: "",
    redirect: "/login",
    hidden: true
  },
  {
    path: "/login",
    name: "login",
    hidden: true,
    meta: { keepAlive: false, icon: "component", title: "登录" },
    component: () => import("@/pages/login/login")
  },
  {
    path: "/register",
    name: "register",
    hidden: true,
    meta: { keepAlive: false, icon: "component", title: "注册" },
    component: () => import("@/pages/login/register")
  },
  {
    path: "/password",
    name: "password",
    hidden: true,
    meta: { keepAlive: false, icon: "component", title: "修改密码" },
    component: () => import("@/pages/login/password")
  },
  {
    path: "/user",
    name: "user",
    hidden: true,
    meta: { keepAlive: true, icon: "component", title: "用户管理" },
    component: () => import("@/pages/user/index")
  },
  {
    path: "/product/Category",
    name: "productCategory",
    hidden: false,
    meta: { keepAlive: true, title: "产品 > 产品线" },
    component: () => import("@/pages/productCategory/index")
  },
  {
    path: "/product",
    name: "product",
    hidden: false,
    meta: { keepAlive: true, title: "产品 > 产品型号" },
    component: () => import("@/pages/product/index")
  },
  {
    path: "/productReport",
    name: "productReport",
    hidden: false,
    meta: { keepAlive: true, title: "生产月报 > 月报管理" },
    component: () => import("@/pages/productReport/list")
  },
  {
    path: "/productReport/:id",
    name: "productReportId",
    hidden: false,
    meta: { keepAlive: false, title: "生产月报 > 月报看板" },
    component: () => import("@/pages/productReport/detail")
  },
  {
    path: "/component",
    name: "component",
    hidden: false,
    meta: { keepAlive: true, title: "物料" },
    component: () => import("@/pages/component/index")
  },
  {
    path: "/component/group",
    name: "componentGroup",
    hidden: false,
    meta: { keepAlive: true, title: "物料 > 物料分组" },
    component: () => import("@/pages/component/group")
  },
  {
    path: "/quotation",
    name: "quotationList",
    hidden: false,
    meta: { keepAlive: true, title: "报价单" },
    component: () => import("@/pages/quotation/list")
  },
  {
    path: "/quotation/detail",
    name: "quotation",
    hidden: false,
    meta: { keepAlive: true, title: "报价单详情" },
    component: () => import("@/pages/quotation/detail")
  },
  {
    path: "/quotation/detailRead",
    name: "detailRead",
    hidden: false,
    meta: { keepAlive: true, title: "报价单详情" },
    component: () => import("@/pages/quotation/detailRead")
  },
  {
    path: "/personalAssets",
    name: "personalAssets",
    hidden: false,
    meta: { keepAlive: true, title: "个人资产" },
    component: () => import("@/pages/personalAssets/index")
  },
  {
    path: "/system",
    name: "system",
    hidden: false,
    meta: { keepAlive: true, title: "配置管理" },
    component: () => import("@/pages/system/index")
  },
  {
    path: "/examine",
    name: "examine",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 审核订单" },
    component: () => import("@/pages/procedures/examine/index")
  },
  {
    path: "/examineDetail",
    name: "examineDetail",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 审核订单" },
    component: () => import("@/pages/procedures/examine/detail")
  },
  {
    path: "/plan/pick-material",
    name: "picking",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 领料计划" },
    component: () => import("@/pages/procedures/picking/index")
  },
  {
    path: "/plan/produce",
    name: "productionAssembly",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 生产装配计划" },
    component: () => import("@/pages/procedures/productionAssembly/index")
  },
  {
    path: "/plan/initial-inspection",
    name: "newInspect",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 初检计划" },
    component: () => import("@/pages/procedures/newInspect/index")
  },
  {
    path: "/plan/preburning",
    name: "oldInspect",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 老化计划" },
    component: () => import("@/pages/procedures/oldInspect/index")
  },
  {
    path: "/plan/final-inspection",
    name: "endInspect",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 终检计划" },
    component: () => import("@/pages/procedures/endInspect/index")
  },
  {
    path: "/plan/package",
    name: "package",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 包装计划" },
    component: () => import("@/pages/procedures/package/index")
  },
  {
    path: "/plan/transport",
    name: "logistics",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 物流计划" },
    component: () => import("@/pages/procedures/logistics/index")
  },

  {
    path: "/workDetail",
    name: "workDetail",
    hidden: false,
    meta: { keepAlive: true, title: "智造 > 随工单" },
    component: () => import("@/pages/workOrder/detail")
  },
  {
    path: "/role",
    name: "role",
    hidden: false,
    meta: { keepAlive: true, title: "角色管理" },
    component: () => import("@/pages/role/index")
  },
  {
    path: "/log",
    name: "log",
    hidden: false,
    meta: { keepAlive: true, title: "日志" },
    component: () => import("@/pages/log/index")
  },
  {
    path: "/requirement",
    name: "requirement",
    hidden: false,
    meta: { keepAlive: true, title: "需求提交" },
    component: () => import("@/pages/requirement/index")
  },
  {
    path: "/requirementConfig",
    name: "requirementConfig",
    hidden: false,
    meta: { keepAlive: true, title: "配置方案" },
    component: () => import("@/pages/requirement/configPlan")
  }
];
// }
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js